export const SET_MULTI_AUTOSTASH = 'SET_MULTI_AUTOSTASH';

export const setMultiAutostash = (data) => {
  return {
    type: SET_MULTI_AUTOSTASH,
    data,
  };
};

export const SET_STASH_BANK = 'SET_STASH_BANK';
export const setStashBank = (data) => ({
  type: SET_STASH_BANK,
  data,
});
